import { Route, Routes } from 'react-router-dom';
import { PickerView } from './views/PickerView';
import { PlayerView } from './views/PlayerView';

export function DosArcadePage() {
  return (
    <Routes>
      <Route index element={<PickerView />} />
      <Route path=":slug" element={<PlayerView />} />
    </Routes>
  );
}
